import LocalAuth from '@shamrock-core/common/authentication/local-authentication';
import { NoAuthService } from './service';
import Axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import gk2 from '@shamrock-core/gk2';

const Config = require('Config');

class SessionService extends NoAuthService {
  constructor() {
    super(Config.sessionServiceUrl);
  }

  async createToken(clientNo, password) {
    const base64String = btoa(`${clientNo}:${password}`);
    const axios = Axios.create({
      baseURL: `${Config.sessionServiceUrl}`,
      headers: {
        Authorization: `basic ${base64String}`,
      },
    });

    return await axios.post(
      '/v2/invoicemanager',
      {},
      {
        headers: {
          Authorization: `basic ${base64String}`,
        },
      },
    );
  }

  async logout(token: string, removeDeviceIdDoc?: boolean) {
    const axios = Axios.create({
      baseURL: `${Config.sessionServiceUrl}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    axios.interceptors.request.use(
      async (config: AxiosRequestConfig): Promise<AxiosRequestConfig> => {
        const token = LocalAuth.getTokenValue();
        const deviceId = localStorage.getItem('device_id');

        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        config = gk2.webInterceptor(config, token === 'trialToken', deviceId);
        return config;
      },
      (error: AxiosError): Promise<AxiosError> => Promise.reject(error),
    );

    let deviceId: string;
    if (removeDeviceIdDoc) {
      deviceId = localStorage.getItem('device_id');
    }

    const baseUrl = '/v2/session';

    const url = deviceId ? `/v2/session/logout?device_id=${deviceId}` : `${baseUrl}/logout`;

    return await axios.delete(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }
  public checkSession(token: string): Promise<AxiosResponse<TokenReturn>> {
    return this.axios.request<TokenReturn>({
      method: 'GET',
      url: '/v2/session',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    });
  }
}

interface TokenReturn extends Record<string, unknown> {
  user: string;
  token: string;
  // eslint Disabled because the services return cannot be changed.
  // eslint-disable-next-line camelcase
  last_access_date: Date;
};

export default new SessionService()
